import fetchAPI from '../../fetchAPI';

export const callGetSyncCoreLocations = async (): Promise<iResponse<any>> => {
  const response: iResponse<any> = await fetchAPI({
    method: `GET`,
    route: `core/sync-locations`
  });

  return response;
};

export default callGetSyncCoreLocations;
